import { styled } from '@mui/material/styles'

export const FieldWrapper = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: '15px',
  paddingBottom: '50px',
})

export const DateWrapper = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: '5px',
})
